<template>
  <div v-if="has_pinned_message" class="pinned-message">
    <b-alert v-b-popover.hover.top="tooltip" class="pinned-message__alert" :variant="variant" show>
      <vb-icon class="pinned-message__icon" :name="'info'" :color="sass('vb-body-color')" :size="14" />
      <span class="pinned-message__title" v-html="title"></span>
    </b-alert>
  </div>
</template>


<script>
import {get_config} from "@src/utilities"

export default {
  name: 'pinned-message',
  components: {
  },
  data() {
    return {
      title: get_config('guiSettings.pinnedMessage.title', ''),
      tooltip: get_config('guiSettings.pinnedMessage.tooltip', ''),
      variant: get_config('guiSettings.pinnedMessage.variant', ''),
    }
  },
  computed: {
    has_pinned_message() {
      return !!this.title;
    },
  },
}
</script>

<style lang="scss" scoped>

.pinned-message {
  display:flex;
  justify-content: center;
  align-items: center;
  margin-bottom:0;
  text-align:center;
  width:100%;

  .pinned-message__alert {
    flex:1;
    width:100%;
    display:flex;
    justify-content: center;
    align-items: center;
    margin-bottom:0;
  }

  .pinned-message__icon {
    margin-right: 5px;
  }
}

</style>